import {API_IMAGE_FILTERS, API_IMAGES} from "../constants/api";
import Mediator from "../services/Mediator";
import {
  APPLY_VISIONHUB_FILTER,
  FAIL,
  START,
  SUCCESS
} from "../constants/action-types";
import {addImage} from "./add-image";
import delay from "../../../utils/delay";
import trackEvent from "../../../utils/track-event";

const fetchProcessingStatus = async (id) => {
  let timeout = false;

  setTimeout(() => (timeout = true), 50000);

  while (!timeout) {
    await delay(2500);
    const result = await fetch(`${API_IMAGES}/${id}`).then((res) => {
      if (res.status >= 400) {
        throw new Error(`Error`);
      }
      return res.json();
    });
    if (result[`picture_processing`]) {
      continue;
    }
    return result.id;
  }

  throw new Error(`Processing timeout`);
};

const waitForProcessing = (id) => (dispatch) => {
  fetchProcessingStatus(id)
    .then((processedId) => {
      dispatch(addImage(processedId));
      dispatch({
        type: APPLY_VISIONHUB_FILTER + SUCCESS
      });
    })
    .catch((error) => {
      dispatch({
        type: APPLY_VISIONHUB_FILTER + FAIL,
        error
      });
    });
};

export const applyVisionHubFilter = (selected, filter) => (
  dispatch,
  getState
) => {
  if (!selected.remoteId) {
    return false;
  }

  const formData = new FormData();
  formData.append(`authenticity_token`, getState().authenticityToken);
  formData.append(`image_filter[original_id]`, selected.remoteId);
  formData.append(`image_filter[filter]`, filter);

  dispatch({
    type: APPLY_VISIONHUB_FILTER + START
  });

  fetch(`${API_IMAGE_FILTERS}`, {
    credentials: `same-origin`,
    method: `post`,
    body: formData
  })
    .then((res) => {
      if (res.status >= 400) {
        throw new Error(`Error`);
      }
      return res.json();
    })
    .then(({id}) => {
      Mediator.removeActive();
      dispatch(waitForProcessing(id));
    })
    .catch((error) => {
      dispatch({
        type: APPLY_VISIONHUB_FILTER + FAIL,
        error
      });
    });

  trackEvent({
    category: `Editor`,
    action: `VisionHub Filter`,
    label: filter
  });
};
